import ActionTypeItem from "../ActionTypeItem";

export default class FinalizarComando extends ActionTypeItem {
    ejecutar(estado, nuevoEstado) {
        nuevoEstado.flag.procesandoComando = false;
        return nuevoEstado;
    }
}
